import { useMutation, UseMutationResult, useQueryClient } from '@tanstack/react-query';
import { UpdateViewRequest } from '../../Model/requests/UpdateViewRequest';
import { useContext } from 'react';
import ServicesContext from '../../global/services/ServicesContext';
import { mutateViewsKeys } from './mutateKeyFactory';
import { viewsKeys } from './queryKeyFactory';

export function useUpdateView(): UseMutationResult<boolean, unknown, UpdateViewRequest, unknown> {
  const servicesCtx = useContext(ServicesContext);
  const queryClient = useQueryClient();

  const updateView = (updateViewRequest: UpdateViewRequest): Promise<boolean> => {
    if (servicesCtx?.viewsService) {
      return servicesCtx.viewsService.updateView(updateViewRequest);
    }
    throw new Error('Services context not initialized');
  };

  return useMutation({
    mutationKey: mutateViewsKeys.updateView,
    mutationFn: (request: UpdateViewRequest) => updateView(request),
    onSuccess: async data => {
      if (data) {
        await queryClient.invalidateQueries({ queryKey: viewsKeys.all });
      }
    }
  });
}
